import axios from 'axios'

export default {
  baseURL: process.env.BASE_URL + 'api/LoopAi',

  sendChatRequest(sessionId, message) {
    return axios.post('chat',        
    {
      sessionId: sessionId,
      message: message
    },
    {
      baseURL: this.baseURL,        
    })
    .then(function (response) {
      return response;
    })
    .catch(function (error) {
      console.log(error);
      return { data: null, error: error }
    });
  },
  getChatHistory(pageIndex = 0, pageSize = 10){
    return axios.get("chat-summaries",
      {
        baseURL: this.baseURL,
        params: {pageIndex, pageSize}
      }
    ) 
    .then(function (response) {
      return response;
    })
    .catch(function (error) {
      console.log(error);
      return { data: null, error: error }
    });
  },
  getChat(sessionId){
    return axios.get("chat",
      {
        baseURL: this.baseURL,
        params: {sessionId}
      }
    ) 
    .then(function (response) {
      return response;
    })
    .catch(function (error) {
      console.log(error);
      return { data: null, error: error }
    });
  },
  getPredefinedPrompts(localizationId){
    return axios.get("predefined-prompts",
      {
        baseURL: this.baseURL,
        params: { "localization-id": localizationId }
      }
    ) 
    .then(function (response) {
      return response;
    })
    .catch(function (error) {
      console.log(error);
      return { data: null, error: error }
    });
  },
  deleteChatHistory(sessionId){
    return axios.delete(`chat/${sessionId}`,
      {
        baseURL: this.baseURL
      }
    ) 
    .then(function (response) {
      return response;
    })
    .catch(function (error) {
      console.log(error);
      return { data: null, error: error }
    });
  },
}
